import { useSelector, useDispatch } from "react-redux";
import {DataGrid, gridClasses, GridToolbar} from '@mui/x-data-grid';
/*
import {
    Box,
    Button,
    Divider,
    Icon,
    IconButton,
    List,
    ListItem,
    ListItemText,
    MenuItem,
    Select,
    TextField
} from "@mui/material";
*/
import {
    Box,
    Button,
    MenuItem,
    Select,
    TextField
}from "@mui/material";

import { styled } from '@mui/material/styles';
//import {stringSortComparator, phoneNumberSortComparator } from "./utilities/string";
import {useEffect, useState} from "react";
import {createUser, getUsers} from "./actions/users";
import {addUser, setUsers} from "./reducers/users";
//import {useNavigate, useParams} from "react-router-dom";
import {useParams} from "react-router-dom";
//import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
//import {useCookies} from "react-cookie";
//import jwt_decode from "jwt-decode";
//import roles, {userManagementRoles} from "./utilities/roles";
import roles from "./utilities/roles";

const columns = [
    { field: 'id', headerName: 'ID', width: 100, editable: false },
    { field: 'username', headerName: 'Username', width: 250, editable: false, },
    { field: 'role_name', headerName: 'Role', width: 250, editable: false, },
]

const pageSizeOptions = [20];

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`&`]: { height: '850px' },
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: '#F8F8F8'
    },
    [`& .${gridClasses.row}.Mui-selected`]: {
        backgroundColor: '#006225', // TODO make this match Compucycle branding guidelines,
        color: 'white'
    },
    [`& .${gridClasses.row}.Mui-selected:hover`]: {
        backgroundColor: '#009f3c', // TODO make this match Compucycle branding guidelines,
        color: 'white'
    },
}));

const UserManagement = (props = {}) => {
    //const navigate = useNavigate();
    const users = useSelector(state => state.users.value )
    const auth = useSelector(st => st.auth.value )
    //const [cookies, setCookie, removeCookie] = useCookies(['access_token']);
    //const [cookies] = useCookies(['access_token']);
    //const decoded = jwt_decode(cookies.access_token);
    //const canManageUsers = userManagementRoles.includes(decoded.user.role);

    const dispatch = useDispatch();
    const { id } = useParams();
    const [ isLoaded, setIsLoaded ] = useState(false);

    const [ selectedUser, setSelectedUser ] = useState(null);
    const [ cleanUser, setCleanUser ] = useState(null);
    //const [setCleanUser ] = useState(null);
    const [ newUser, setNewUser ] = useState({});
    const [ dirtyFlag, setDirtyFlag ] = useState(false);
    //const [setDirtyFlag ] = useState(false);
    
    const [ showNewUserDialog, setShowNewUserDialog ] = useState(false);
    const [ creatingUser, setCreatingUser ] = useState(false);
    //const [ updatingUser, setUpdatingUser ] = useState(false);
    const [ updatingUser] = useState(false);

    const updateUserField = (field, value) => {
        const updatedUser = Object.assign({}, selectedUser, { [field]: value } );
        setSelectedUser(updatedUser);
        setDirtyFlag(true);
    }

    const updateNewUserField = (field, value) => {
        const updatedUser = Object.assign({}, newUser, { [field]: value } );
        setNewUser(updatedUser);
    }

    useEffect(() => {
        const fetchData = () => async (dispatch) => {
            if( users.length === 0 ) {
                const updatedUsers = await getUsers(auth.token);
                const updatedUsersData = updatedUsers.data.map((user) => {
                    return Object.assign({}, user, { role_name: roles[user.roles[0]]});
                });
                dispatch(setUsers(updatedUsersData));
            }
            setIsLoaded(true);
        }
        dispatch(fetchData());
    }, [dispatch, users, auth]);

    useEffect(() => {
        if(id !== null && id !== '') {
            setSelectedUser(users.find(c => c.id === parseInt(id)));
        }
    }, [isLoaded,id,users]);

    const rowClickListener = (
        params, // GridRowParams
        event, // MuiEvent<React.MouseEvent<HTMLElement>>
        details, // GridCallbackDetails
    ) => {
        if( selectedUser != null ) {
            if( selectedUser.id === params.row.id ) {
                setSelectedUser(null);
                setCleanUser(null);
            } else {
                setSelectedUser(params.row);
                setCleanUser(params.row);
            }
        } else {
            setSelectedUser(params.row);
            setCleanUser(params.row);
        }
    };

    return (
        <Box sx={{  height: '100vh', width: '100%' }}>
            <div style={{ paddingTop: 10}}>
                <Button style={{margin: 10}} onClick={() => setShowNewUserDialog(true)} variant="contained" color="primary">New User</Button>
            </div>
            {selectedUser == null ? null : (
                <div style={{ position: "relative"}}>
                <div style={{ "display": "flex", flexDirection: "row", padding: 20}}>
                    <div style={{display: "flex", flexDirection: "column", paddingRight: 20}}>
                    <TextField onChange={(e) => updateUserField('username', e.target.value)} style={{marginTop: 10}} id="user-name" label="User Name" variant="outlined" value={selectedUser.username} />
                        <div style={{marginTop: 10}}>
                            <Select
                                style={{marginRight: 10}}
                                id="user-role"
                                value={selectedUser.roles[0]}
                                label="Role"
                                onChange={(e) => updateUserField('role', e.target.value)}
                            >
                                {Object.entries(roles).map(([k,v]) => <MenuItem key={k} value={k}>{v}</MenuItem>)}
                            </Select>
                        </div>
                </div>
                </div>
                    {updatingUser ? (
                        <div style={{position: "absolute", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "#00000022", display: "flex", justifyContent: "center", alignItems: "center"}}>
                            <div className="lds-roller">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    ) : null }
                </div>
            )}
                <StripedDataGrid
                    slots={{ toolbar: GridToolbar }}
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                    }
                    rows={users}
                    columns={columns}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 20,
                            },
                        },
                    }}
                    density="compact"
                    pageSizeOptions={pageSizeOptions}
                    onRowClick={rowClickListener}
                />
            {!isLoaded ? (
                <div style={{position: "fixed", top:0, bottom: 0, left: 0, right:0, backgroundColor: "#00000022", display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <div className="lds-roller">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            ) : null}
            {showNewUserDialog ? (
                <div style={{position: "fixed", top:0, bottom: 0, left: 0, right:0, backgroundColor: "#00000022", display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <div style={{display: "flex", flexDirection: "column", background: "white"}}>
                        <div style={{fontSize: 20, fontWeight: "bold", padding: 20, alignSelf: "center", display: "flex"}}>New User</div>
                        <div style={{ "display": "flex", flexDirection: "row", paddingLeft: 20, paddingRight: 20, background: "white"}}>
                            <div style={{display: "flex", flexDirection: "column", paddingRight: 20}}>
                                <TextField onChange={(e) => updateNewUserField('username', e.target.value)} style={{marginTop: 10}} id="user-name" label="User Name" variant="outlined" value={newUser.username} />
                            </div>
                        </div>
                        <div style={{ padding: 20, display: "flex", flexDirection: "row-reverse"}}>
                            <Button style={{margin: 10}} onClick={async () => {
                                setCreatingUser(true);
                                const result = await createUser(auth.token, newUser);
                                if( result.status === "success") {
                                    dispatch(addUser(Object.assign({}, newUser, {id: result.id})));
                                } else {
                                    console.log("Error saving asset: " + JSON.stringify(result.error));
                                }
                                setCreatingUser(false);
                                setShowNewUserDialog(false);
                                setNewUser({});
                            }} variant="contained" color="primary">Save</Button>
                            <Button style={{margin: 10}} onClick={() => { setShowNewUserDialog(false); setNewUser({});}} variant="contained" color="secondary">Cancel</Button>
                            {creatingUser ? (
                                <div style={{position: "fixed", top:0, bottom: 0, left: 0, right:0, backgroundColor: "#00000022", display: "flex", justifyContent: "center", alignItems: "center"}}>
                                    <div className="lds-roller">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                </div>
                            ) : null }
                        </div>
                    </div>
                </div>
            ) : null}
        </Box>
    )
}

export default UserManagement;
